import httpClient from '../httpClient';

export async function getAllProdutos() {
  try {
    const response = await httpClient.get('/api/produtodaf');

    // Verifica se response.data existe antes de acessar registros
    if (!response.data || !Array.isArray(response.data.registros)) {
      console.warn('API retornou um formato inesperado:', response.data);
      return [];
    }

    return response.data.registros;
  } catch (error) {
    console.error('Erro ao obter lista de Produtos DAF:', error);
    return []; // Retorna array vazio para evitar erros no .map()
  }
}

export async function getProdutosByUsuario() {
  try {
    const response = await httpClient.get(
      `/api/produtodaf/produtos-por-usuario`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter Produtos DAF do usuário: ' + error);
  }
}

export async function getProdutoDAF(id: string) {
  try {
    const response = await httpClient.get(`/api/produtodaf/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Produto DAF: ' + error);
  }
}

export async function getProdutoDAFIncorporacao(id: string) {
  try {
    console.log('Buscando Incorporação para Produto DAF ID:', id);
    const response = await httpClient.get(
      `/api/produtodafincorporacaosus/produtodaf/${id}`,
    );
    console.log('Resposta da Incorporação:', response.data);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados da Incorporação no SUS: ' + error);
  }
}

export const getProdutoDAFSimples = async () => {
  try {
    const response = await httpClient.get(
      '/api/produtodaf/lista-produtos-simples',
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Lista Simples de Produtos DAF: ' + error);
  }
};

export async function getProdutosByDenominacaoGenericaId(id: string) {
  try {
    const response = await httpClient.get(
      `/api/produtodaf/denominacaogenerica/${id}`,
    );

    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getProdutoDAFOutroSistema(id: string) {
  try {
    const response = await httpClient.get(
      `/api/produtooutrosistema/produtodaf/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados da Incorporação no SUS: ' + error);
  }
}

export async function getProdutoPorComponente(componente: string | null) {
  if (!componente) return;

  try {
    const response = await httpClient.get(
      `/api/produtodaf/componentes/${componente}`,
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao obter lista de Produtos DAF:', error);
    return []; // Retorna array vazio para evitar erros no .map()
  }
}

export async function createProdutoDAF(payload: Record<string, unknown>) {
  try {
    const response = await httpClient.post(`/api/produtodaf/`, payload);

    return response.data;
  } catch (error) {
    console.error('Erro ao criar Produto DAF:', error);
    throw error;
  }
}

export async function updateProdutoDAF(
  id: string,
  payload: Record<string, unknown>,
) {
  try {
    const response = await httpClient.patch(`/api/produtodaf/${id}`, payload);

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar Produto DAF:', error);
    throw error;
  }
}

export async function deleteProdutoDAF(id: string) {
  try {
    await httpClient.delete(`/api/produtodaf/${id}`);
  } catch (error) {
    console.error('Erro ao deletar Produto DAF:', error);
    throw error;
  }
}

export async function createProdutoDAFIncorporacao(
  payload: Record<string, unknown>,
) {
  try {
    const response = await httpClient.post(
      `/api/produtodafincorporacaosus/`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao criar Incorporação do Produto DAF:', error);
    throw error;
  }
}

export async function updateProdutoDAFIncorporacao(
  id: string,
  payload: Record<string, unknown>,
) {
  try {
    const response = await httpClient.patch(
      `/api/produtodafincorporacaosus/${id}`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar Incorporação do Produto DAF:', error);
    throw error;
  }
}

export async function deleteProdutoDAFIncorporacao(id: string) {
  try {
    await httpClient.delete(`/api/produtodafincorporacaosus/${id}`);
  } catch (error) {
    console.error('Erro ao deletar Incorporação do Produto DAF:', error);
    throw error;
  }
}

export async function createProdutoDAFOutroSistema(
  payload: Record<string, unknown>,
) {
  try {
    const response = await httpClient.post(
      `/api/produtooutrosistema/`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao criar Produto DAF em Outro Sistema:', error);
    throw error;
  }
}

export async function updateProdutoDAFOutroSistema(
  id: string,
  payload: Record<string, unknown>,
) {
  try {
    const response = await httpClient.patch(
      `/api/produtooutrosistema/${id}`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar Produto DAF em Outro Sistema:', error);
    throw error;
  }
}

export async function deleteProdutoDAFOutroSistema(id: string) {
  try {
    await httpClient.delete(`/api/produtooutrosistema/${id}`);
  } catch (error) {
    console.error('Erro ao deletar Produto DAF em Outro Sistema:', error);
    throw error;
  }
}
